<template>
  <div id="aboutus">
    <div class="inner">
      <div class="top">
        <div class="top_box">
          <div class="top_box_top">
            <div class="top_title">{{ $t("home_aboutus_title") }}</div>
            <div class="top_img">
              <img src="../../assets/Keeta2/quote@2x.png" alt="" />
            </div>
          </div>
          <div class="top_desc">
            {{ $t("home_aboutus_desc_1") }}
            <span style="font-weight: 900">{{
              $t("home_aboutus_desc_2")
            }}</span>
            {{ $t("home_aboutus_desc_3") }}
            <span style="font-weight: 900">{{
              $t("home_aboutus_desc_4")
            }}</span>
            {{ $t("home_aboutus_desc_5") }}
          </div>
          <div class="top_list">
            <div
              class="top_list_item"
              v-for="(item, index) of topLists"
              :key="index"
            >
              <div class="top_list_item_img">
                <el-image :src="item.img"></el-image>
              </div>
              <div class="top_list_item_desc">
                {{ item.desc }}
              </div>
            </div>
          </div>
          <div class="top_note">
            {{ $t("home_aboutus_note") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCountryByDomain } from "@/common/config";
export default {
  name: "AboutusView",
  data() {
    return {
      topList: [
        {
          img: require("@/assets/Keeta2/benefit1@2x.png"),
          desc: "home_aboutus_list_1",
        },
        {
          img: require("@/assets/Keeta2/benefit2@2x.png"),
          desc: "home_aboutus_list_2",
        },
        {
          img: require("@/assets/Keeta2/benefit3@2x.png"),
          desc: "home_aboutus_list_3",
        },
      ],
    };
  },
  computed: {
    country() {
      return getCountryByDomain(window.location.hostname);
    },
    topLists() {
      return this.topList.map((item) => {
        return {
          img: item.img,
          desc: this.$t(item.desc),
        };
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/styles/_variables.scss";
#aboutus {
  min-width: $min-width;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0 120px 0;
  background-color: white;
  .inner {
    width: 1200px;
  }

  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
    .top_box {
      width: 100%;
      min-width: 431px;
      .top_box_top {
        display: flex;
        .top_title {
          color: #000000;
          font-weight: 900;
          font-size: 1.3rem;
          font-family: $title-font;
        }
        .top_img {
          margin-left: 40px;
          img {
            width: 103.5px;
            height: 80px;
          }
        }
      }

      .top_desc {
        font-weight: 400;
        font-size: 0.74rem;
        margin-top: 40px;
        line-height: 46px;
        font-family: $content-font;
      }
    }

    &_list {
      margin-top: 85px;
      display: flex;
      justify-content: space-between;
      text-align: center;

      &_item {
        width: 345px;

        &_img {
          height: 215px;
        }
        &_desc {
          font-weight: 400;
          font-size: $font-size-small;
          line-height: 40px;
          margin-top: 30px;
          font-family: $content-font;
        }
      }
    }
    .top_note {
      font-weight: 400;
      color: #999999;
      font-size: $font-size-mini;
      letter-spacing: 0.0375vw;
      margin-top: 60px;
      line-height: 32px;
      position: relative;
      text-align: center;
      font-family: $content-font;
    }
  }
}
</style>